import $, { Cash } from 'cash-dom';

/**
 * Attach a "Show More"-like link handler
 * @description 'More' state is when the content is expanded, and 'less' state
 * is when the content is collapsed. Default is assumed to be 'less'.
 * @param {string | Cash} triggerSel Selector of the link
 * @param {string | Cash | function(HTMLElement): Cash} contentSel Selector of the content
 * @param {string} [moreText="Show More"] Text of the link in 'more' state
 * @param {string} [lessText="Show Less"] Text of the link in 'less' state
 * @param {string} [expandClass="open"] Class to add/remove for expanding/collapsing
 */
export default function attachShowMoreHandler(triggerSel, contentSel,
    moreText, lessText, expandClass)
{
    if (moreText == null)
        moreText = "Show More";
    if (lessText == null)
        lessText = "Show Less";
    if (expandClass == null)
        expandClass = "open";

    $(triggerSel).on("click", function () {
        var link$ = $(this);
        var readState = link$.data("read-state");
        if (typeof contentSel == "function")
            var content$ = contentSel(this);
        else
            var content$ = $(contentSel);
        
        if (readState === "more") {
            link$.text(moreText);
            link$.data("read-state", "less");
            content$.removeClass(expandClass);
            return;
        }

        link$.text(lessText);
        link$.data("read-state", "more");
        content$.addClass(expandClass);
    });
}
